import { EnvironmentProviders, Provider } from "@angular/core";
import { Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";

/**
 * Providers específicos do visual selecionado em build-time (mesmo slot dos
 * fileReplacements das rotas). O visual WEB não precisa de nenhum.
 */
export const visualProviders: Array<Provider | EnvironmentProviders> = [];

export const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("./tabs/tabs.routes").then((m) => m.routes),
  },
  {
    path: "login",
    loadComponent: () =>
      import("./pages/login/login.page").then((m) => m.LoginPage),
  },
  {
    path: "profile",
    loadComponent: () =>
      import("./pages/profile/profile.page").then((m) => m.ProfilePage),
  },
  {
    path: "desafio-quental-infantte",
    loadComponent: () =>
      import("./pages/home/home.page").then((m) => m.HomePage),
  },
  {
    path: "desafio-quental-infantte-signin",
    loadComponent: () =>
      import("./pages/home/home.page").then((m) => m.HomePage),
  },
  {
    path: "desafio-quental-infantte-sucesso",
    loadComponent: () =>
      import("./pages/home/home.page").then((m) => m.HomePage),
  },
  {
    path: "confirm-register-promotion-success",
    loadComponent: () =>
      import("./pages/home/home.page").then((m) => m.HomePage),
  },
  {
    path: "confirm-success",
    loadComponent: () =>
      import("./pages/home/home.page").then((m) => m.HomePage),
  },
  {
    path: "confirm-success-indicate",
    loadComponent: () =>
      import("./pages/home/home.page").then((m) => m.HomePage),
  },
  {
    path: "speciality",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/speciality/speciality.page").then(
        (m) => m.SpecialityPage,
      ),
  },
  {
    path: "financial",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/financial/financial.page").then((m) => m.FinancialPage),
  },
  {
    path: "profile-create",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/register-profile/register-profile.page").then(
        (m) => m.RegisterProfilePage,
      ),
  },
  {
    path: "hires-works",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/my-jobs-services/my-jobs-services.page").then(
        (m) => m.MyJobsServicesPage,
      ),
  },
  {
    path: "messages",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/mensagens/mensagens.page").then((m) => m.MensagensPage),
  },
  {
    path: "hiring",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/hiring/hiring.page").then((m) => m.HiringPage),
  },
  {
    path: "extrato",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/extrato/extrato.page").then((m) => m.ExtratoPage),
  },
  {
    path: "cadastro/:codigo",
    loadComponent: () =>
      import("./pages/cadastro/cadastro.page").then((m) => m.CadastroPage),
  },
  {
    path: "nova-senha/:uid/:token",
    loadComponent: () =>
      import("./pages/nova-senha/nova-senha.page").then((m) => m.NovaSenhaPage),
  },
  {
    path: "show-hiring",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/show-hiring/show-hiring.page").then((m) => m.ShowHiringPage),
  },
  {
    path: "show-work",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/show-work/show-work.page").then((m) => m.ShowWorkPage),
  },
  {
    path: "cadastro-contratante",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/cadastro-contratante/cadastro-contratante.page").then(
        (m) => m.CadastroContratantePage,
      ),
  },
  {
    path: "favorites",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/favorites/favorites.page").then((m) => m.FavoritesPage),
  },
  {
    path: "indicated",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/indicated/indicated.page").then((m) => m.IndicatedPage),
  },
  {
    path: "estudio",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/estudio/estudio.page").then((m) => m.EstudioPage),
  },
  {
    path: "termos-de-uso",
    data: { doc: "termos" },
    loadComponent: () =>
      import("./pages/legal/legal.page").then((m) => m.LegalPage),
  },
  {
    path: "politica-de-privacidade",
    data: { doc: "privacidade" },
    loadComponent: () =>
      import("./pages/legal/legal.page").then((m) => m.LegalPage),
  },
  {
    path: "prova-de-vida",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./pages/prova-de-vida/prova-de-vida.page").then(
        (m) => m.ProvaDeVidaPage,
      ),
  },
  {
    path: "como-funciona",
    loadComponent: () =>
      import("./pages/como-funciona/como-funciona.page").then(
        (m) => m.ComoFuncionaPage,
      ),
  },
];
